var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScalableServerInfrastructure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0309 91.015C19.9371 89.7111 21.1482 89.2426 22.7615 89.2602C29.9839 89.3265 37.2107 89.3177 44.4376 89.2602C45.6266 89.2514 45.8962 89.6271 45.8918 90.7498C45.8564 101.734 45.8564 112.718 45.8785 123.702C45.8874 127.887 48.0974 130.884 51.8236 131.892C52.9197 132.188 54.0469 132.148 55.1696 132.148C65.7645 132.153 76.355 132.175 86.95 132.122C88.3158 132.113 88.771 132.4 88.7534 133.863C88.6694 140.94 88.6782 148.021 88.7445 155.097C88.7622 156.742 88.3644 158.037 86.9898 158.974C64.7523 158.974 42.5149 158.965 20.273 159.005C19.2166 159.005 19 158.788 19 157.732C19.0398 135.494 19.0309 113.257 19.0309 91.015Z",
    fill: "url(#paint0_linear_75_366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.116 9C128.565 9 147.015 9 165.464 9C168.213 9 169 9.80004 169 12.5891C169 49.488 169 86.3868 169 123.286C169 126.022 168.187 126.831 165.406 126.835C128.508 126.835 91.6087 126.835 54.7099 126.835C51.9827 126.835 51.1561 125.995 51.1561 123.237C51.1561 86.3382 51.1561 49.4394 51.1561 12.5405C51.1561 9.80888 51.9959 9.00442 54.7629 9.00442C73.2168 9 91.6662 9 110.116 9ZM65.044 97.4282C62.9622 97.415 60.7919 98.8205 60.1598 101.15C58.8869 105.844 57.6713 110.56 56.637 115.312C55.9121 118.64 59.3907 122.11 62.7058 121.385C67.4574 120.342 72.1957 119.197 76.8633 117.84C80.6646 116.735 81.8138 112.01 79.1662 109.053C78.4502 108.253 77.7076 107.466 76.8854 106.786C76.0235 106.074 76.1164 105.619 76.8854 104.85C100.241 81.5513 123.579 58.2309 146.891 34.884C147.744 34.0309 148.287 33.7304 149.127 34.8398C149.711 35.6089 150.462 36.2631 151.187 36.9128C154.374 39.7726 159.126 38.4201 160.235 34.274C161.402 29.9026 162.489 25.509 163.515 21.1022C164.416 17.2169 161.331 13.7649 157.441 14.5428C152.677 15.4975 147.943 16.6777 143.288 18.0656C139.593 19.1706 138.501 23.6924 140.999 26.6582C141.626 27.4008 142.289 28.1478 143.059 28.7313C144.252 29.6418 144.133 30.2518 143.081 31.2993C120.335 53.9655 97.6333 76.6803 74.9141 99.3731C74.0566 100.231 73.3184 101.698 72.262 101.729C71.1924 101.76 70.4675 100.257 69.61 99.4128C68.4166 98.2371 67.1038 97.4061 65.044 97.4282Z",
    fill: "url(#paint1_linear_75_366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3126 104.355C68.8983 106.728 71.5283 109.146 74.2511 111.644C74.7682 112.121 74.5737 112.974 73.9019 113.186C73.0709 113.451 72.3018 113.557 71.5637 113.752C68.7436 114.499 65.9015 115.175 63.055 115.829C62.6793 115.918 61.7334 116.457 62.0605 115.206C63.002 111.648 63.9434 108.09 64.8142 104.788C64.991 104.125 65.8043 103.886 66.3082 104.35L66.3126 104.355Z",
    fill: "url(#paint2_linear_75_366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.473 30.1457C150.913 28.7047 149.331 27.2328 147.686 25.7123C146.458 24.572 146.984 22.521 148.615 22.1188L154.997 20.5497C156.544 20.1696 157.937 21.5884 157.53 23.1354C156.982 25.1996 156.451 27.2063 155.939 29.1379C155.532 30.6717 153.64 31.2198 152.473 30.1413V30.1457Z",
    fill: "url(#paint3_linear_75_366)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_366",
    x1: 53.8769,
    y1: 89.2598,
    x2: 53.8769,
    y2: 159.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_366",
    x1: 110.078,
    y1: 9,
    x2: 110.078,
    y2: 126.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_366",
    x1: 68.2691,
    y1: 104.109,
    x2: 68.2691,
    y2: 116.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_366",
    x1: 152.306,
    y1: 20.4873,
    x2: 152.306,
    y2: 30.7036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(19 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalableServerInfrastructure);
export default __webpack_public_path__ + "static/media/Scalable_Server_Infrastructure.f31ffe97ccd3a7910674fd19ee0a9d0c.svg";
export { ForwardRef as ReactComponent };